var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 17,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00049 2.00049H20.9672V22.3561H4.00049V2.00049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4839 3.5C11.6359 3.5 6.28492 5.384 5.66792 5.899C5.48692 6.081 5.47992 6.399 5.51792 8.526C5.53692 9.552 5.56192 10.947 5.56192 12.879C5.56192 18.08 11.2839 20.389 12.4829 20.814C13.6809 20.387 19.4059 18.065 19.4059 12.879C19.4059 10.949 19.4309 9.555 19.4489 8.529C19.4879 6.4 19.4809 6.082 19.2879 5.889C18.6819 5.384 13.3319 3.5 12.4839 3.5ZM12.4839 22.356C12.4109 22.356 12.3379 22.346 12.2669 22.324C11.9319 22.223 4.06192 19.761 4.06192 12.879C4.06192 10.959 4.03692 9.572 4.01892 8.554C3.97292 6.014 3.96292 5.484 4.61792 4.828C5.40492 4.041 11.3509 2 12.4839 2C13.6169 2 19.5629 4.041 20.3489 4.828C21.0049 5.484 20.9949 6.014 20.9489 8.557C20.9309 9.575 20.9059 10.962 20.9059 12.879C20.9059 19.761 13.0359 22.223 12.7009 22.324C12.6299 22.346 12.5569 22.356 12.4839 22.356Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3627 14.5754C14.1707 14.5754 13.9787 14.5024 13.8327 14.3554L10.0747 10.5974C9.78173 10.3044 9.78173 9.83038 10.0747 9.53738C10.3677 9.24438 10.8417 9.24438 11.1347 9.53738L14.8927 13.2954C15.1857 13.5884 15.1857 14.0624 14.8927 14.3554C14.7467 14.5024 14.5547 14.5754 14.3627 14.5754Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6052 14.5754C10.4132 14.5754 10.2212 14.5024 10.0752 14.3554C9.78222 14.0624 9.78222 13.5884 10.0752 13.2954L13.8332 9.53738C14.1262 9.24438 14.6002 9.24438 14.8932 9.53738C15.1862 9.83038 15.1862 10.3044 14.8932 10.5974L11.1352 14.3554C10.9892 14.5024 10.7972 14.5754 10.6052 14.5754Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldFail);
export default __webpack_public_path__ + "static/media/ShieldFail.e02c22f4ac0cb37746b2c6cbc885ab1c.svg";
export { ForwardRef as ReactComponent };